import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { BalanceListItemMapper, BalanceOverviewMapper, MemberBalanceMapper } from '@/api/mapper/balance';
import { getBalance, getBalances } from '@/api/service/balance';
import type { PageQuery } from '@/api/type/payment';

export const balanceKeys = {
  all: ['balances'] as const,
  list: (query: PageQuery) => [...balanceKeys.all, 'list', query] as const,
  detail: (memberId: string) => [...balanceKeys.all, 'detail', memberId] as const,
};

/** One page of the Balances table, searched and filtered by the backend, with the page summary. */
export function useBalancesQuery(query: PageQuery, enabled = true) {
  return useQuery({
    queryKey: balanceKeys.list(query),
    queryFn: async () => {
      const response = await getBalances(query);
      return {
        balances: (response.data ?? []).map(BalanceListItemMapper),
        total: response.total ?? 0,
        overview: BalanceOverviewMapper(response.summary),
      };
    },
    placeholderData: keepPreviousData,
    enabled,
  });
}

export function useMemberBalanceQuery(memberId?: string | null, enabled = true) {
  return useQuery({
    queryKey: balanceKeys.detail(memberId ?? 'none'),
    queryFn: async () => MemberBalanceMapper(await getBalance(Number(memberId))),
    enabled: enabled && Boolean(memberId),
  });
}
